// extracted by mini-css-extract-plugin
export default {"root":"ConversationModalQuery-root-e56db2685c49e29b266383f02c139c09","body":"ConversationModalQuery-body-3bb9e9d32a35692932954dc1b33cb847"};